export default "__VITE_ASSET__BDp9YRjM__"